<template>
    <SOSlotModal  
        modal-title="Ubah kasir"
        :modal-id="id"
        :no-padding="true"
        @close="!loading && close()"
    >
        <template v-slot:modal-body>
            <div v-if="!loadingOpen" class="p-4 d-flex-column" style="gap: 10px">
                <template >
                    <SOInputSelect
                        class="p-t-2"
                        title="Pilih Outlet"
                        :selected="formData.outlet.idoutlet"
                        :options="listOutlet"
                        :placeholder="'Pilih Outlet'"
                        @option-selected="(v) => selectedOutlet(v)"
                    />
                    <div v-if="formData.outlet.idoutlet">
                        <label class="remove-margin color-6f7 font-14">
                            Pilih Kasir 
                        </label>
                        <SOInputRadioBig
                            :radio-group="pilihanKasir"
                            :radio-selected="formData.outlet.tipe_pengaturan"
                            @selected-radio="(val) => { formData.outlet.tipe_pengaturan = (val) }"
                        />
                        <div v-show="formData.outlet.tipe_pengaturan == '2'">
                            <div class="">
                                <div class="my-2 rounded" id="customer-select" style="border: 1px solid #C8D0DD;">
                                    <div v-if="listSelectedKasir.length" class="p-x-12 p-t-12 name-container">
                                        <span
                                            v-for="(item, index) in listSelectedKasir"
                                            :key="index"
                                            class="border p-1 rounded"
                                            style="background: #F6F6F6"
                                        >
                                            <label class="pr-2 m-0">{{ item.nama }}</label>
                                            <svg @click="item.isSelected = false" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.529247 1.02876C0.789596 0.768409 1.21171 0.768409 1.47206 1.02876L5.00065 4.55735L8.52925 1.02876C8.7896 0.768409 9.21171 0.768409 9.47206 1.02876C9.73241 1.28911 9.73241 1.71122 9.47206 1.97157L5.94346 5.50016L9.47206 9.02876C9.73241 9.28911 9.73241 9.71122 9.47206 9.97157C9.21171 10.2319 8.7896 10.2319 8.52925 9.97157L5.00065 6.44297L1.47206 9.97157C1.21171 10.2319 0.789596 10.2319 0.529247 9.97157C0.268897 9.71122 0.268897 9.28911 0.529247 9.02876L4.05784 5.50016L0.529247 1.97157C0.268897 1.71122 0.268897 1.28911 0.529247 1.02876Z" fill="#6F7287"/>
                                            </svg>
                                        </span>
                                    </div>
                                    <SOInputSearch
                                        id="cari-kasir"
                                        placeholder="Ketuk untuk menambah kasir"
                                        value=""
                                        autocomplete="off"
                                        :do-searching="cariKasir"
                                        :delay-time="500"
                                        ref="searchInput"
                                    />
                                </div>
                                <div v-if="searcResultKasir.length" class="list-options">
                                    <p class="m-d-4 f-12 f-c-midgrey f-regular">Hasil Pencarian</p>
                                    <div class="name-container">
                                        <template v-for="(item, index) in searcResultKasir">
                                            <span
                                                :key="index"
                                                v-if="!item.isSelected"
                                                class="border p-1 rounded"
                                                style="background: #F6F6F6"
                                                @click="item.isSelected = true"
                                            >
                                                <label class="m-0 pr-2">{{ item.nama }}</label>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00062 0.833374C9.54374 0.833374 9.98404 1.27367 9.98404 1.81679V8.01663H16.1839C16.727 8.01663 17.1673 8.45692 17.1673 9.00005C17.1673 9.54318 16.727 9.98347 16.1839 9.98347H9.98404V16.1833C9.98404 16.7264 9.54374 17.1667 9.00062 17.1667C8.45749 17.1667 8.0172 16.7264 8.0172 16.1833V9.98347H1.81741C1.27428 9.98347 0.833984 9.54318 0.833984 9.00005C0.833984 8.45692 1.27428 8.01663 1.81741 8.01663H8.0172V1.81679C8.0172 1.27367 8.45749 0.833374 9.00062 0.833374Z" fill="white"/>
                                                </svg>
                                            </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                    <SOButton
                        :disable="loading"
                        :loading="loading"
                        text="Simpan"
                        full
                        outline
                        @action="simpan()"
                    />
            </div>
            <div class="d-flex justify-content-center m-4" v-else>
                <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
                <span class="ml-2">Memuat Data...</span>
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import conn from "@/store/utils/connection";
import { mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";

export default {
    name: "ubahOutletSetting",
    components: {
        SOSlotModal,
        SOInputSelect,
        SOIconBase,
        SOInputSearch,
        SOButton,
        SOInputRadioBig,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            id:"modal-ubah-kasir",
            mode: 'default',
            formData: {
                outlet: {
                    idoutlet: null,
                    tipe_pengaturan: 1,
                    idkaryawan: [],
                },
                tipe_pengaturan_kasir: 2
            },
            selectedOptions: '1',
            hiddenOptions: false,
            pilihanKasir: [
                {
                    title: "Semua",
                    name: "jenis-mesin",
                    value: 1,
                    id: "semua",
                },
                {
                    title: "Sebagian",
                    name: "jenis-mesin",
                    value: 2,
                    id: "sebagian",
                },
            ],
            listOutlet: [],
            listKaryawan: [],
            searcResultKasir: [],
            customerOptions: [],
            loadingOpen: false
        }
    },
    methods: {
        async selectedOutlet (idoutlet) {
            this.formData.outlet.idoutlet = idoutlet
            try {
                let res = await conn.get(this.$baseurl +'masterData/owner/meta/list_karyawan?idoutlet=' + idoutlet)
                console.log(res);
                if (res.data.data.length) {
                    this.listKaryawan = res.data.data
                }
                else {
                    this.customerOptions = []
                }
            } catch (error) {
                console.log(error);
            }
        },
        async simpan() {
            let data = new FormData()
            let dispatchEndpoint
            
            if (this.formData.tipe_pengaturan_kasir == 2) {
                if (!this.formData.outlet.idoutlet) {
                    this.$toast.error('Outlet belum dipilih')
                    return
                }
                if (this.formData.outlet.tipe_pengaturan == 2 && !this.listSelectedKasir.length) {
                    this.$toast.error('Kasir belum dipilih')
                    return
                }
                dispatchEndpoint = "updateOutletCanPaidOff"
                data.append("idoutlet", this.formData.outlet.idoutlet)
                data.append("tipe_pengaturan", this.formData.outlet.tipe_pengaturan)
                this.listSelectedKasir.forEach(element => {
                    data.append("idkaryawan[]", element.idkaryawan)
                });
            }
            if (this.formData.tipe_pengaturan_kasir == 1) {
                dispatchEndpoint = "updatePelunasanInvoice"
                data.append("tipe_pengaturan_kasir", 1);
            }
            this.$emit("setLoading", true)
            //setting pengaturan outlet
            try {
                await this.$store.dispatch("pengaturanUmumModule/" + dispatchEndpoint, data)
                this.$toast.success('Pengaturan pelunasan traksaksi berhasil diupdate')
            } catch (error) {
                this.$toast.error(res.msg)
            }
            this.$emit("setLoading", false)
            this.close()
        },
        deleteKasir(id){
            this.$refs.searchInput.clearText()
            this.customerOptions = []
            console.log('delete');
            this.formData.outlet.idkaryawan = this.formData.outlet.idkaryawan.filter((items) => {
                return items.idkaryawan != id
            })

            this.listKaryawan = this.listKaryawan.filter((items) => {
                return this.formData.outlet.idkaryawan.some((item) => {
                    return item.idkaryawan !== items.idkaryawan
                })
            })
        },
        selectKasir(karyawan) {
            this.formData.outlet.idkaryawan.push(karyawan)
            this.searcResultKasir = this.searcResultKasir.filter((item) => {
                return item.idkaryawan != karyawan.idkaryawan
            })
            this.listKaryawan = this.listKaryawan.filter((item) => {
                return item.idkaryawan != karyawan.idkaryawan
            })
        },
        cariKasir(key) {
            if (key) {
				const search = key.toLowerCase()
                this.searcResultKasir = []
                this.listKaryawan.forEach(element => {
                    if (element.nama.toLowerCase().includes(search)) {
                        this.searcResultKasir.push(element)
                    }
                });
            } else {
                this.searcResultKasir = []
            }
        },
        async open(outlet) {
            $("#" + this.id).modal("show");
            this.loadingOpen = true
            this.getListKasir(outlet.idoutlet)
            await this.getListOulet()
            this.listOutlet = []
            this.listOutlet.push({
                id: outlet.idoutlet,
                text: outlet.nama
            })
            this.formData = {
                outlet: {
                    idoutlet: outlet.idoutlet,
                    tipe_pengaturan: outlet.bisa_lunasi_invoice,
                    idkaryawan: [],
                },
                tipe_pengaturan_kasir: 2
            }
            this.loadingOpen = false
        },
        close() {
            this.$refs.searchInput.clearText()
            this.searcResultKasir = []
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        async getListOulet() {
            try {
                let res = await conn.get(this.$baseurl +'masterData/owner/meta/list_outlet')
                this.listOutlet = res.data.data.map(item => {
                    return {
                        id: item.idoutlet,
                        text: item.nama,
                    }
                })
            } catch (error) {
                
            }
        },
        async getListKasir(idoutlet) {
            try {
                let res = await conn.get(this.$baseurl +'masterData/owner/meta/list_karyawan?idoutlet=' + idoutlet)
                this.listKaryawan = res.data.data.map((item) => {
                    return {
                        ...item,
                        isSelected: item.bisa_lunasi_invoice == 1
                    }
                })
                // this.formData.outlet.idkaryawan = res.data.data.filter((item) => {
                //     return item.bisa_lunasi_invoice == 1
                // })
                // this.listKaryawan = res.data.data.filter((item) => {
                //     return item.bisa_lunasi_invoice == 0
                // })
            } catch (error) {
                
            }
        },
    },    
    computed: {
        ...mapGetters("pengaturanUmumModule", {
            pelunasanInvoice: "pelunasanInvoice",
        }),
        listSelectedKasir() {
            return this.listKaryawan.filter((item) => {
                return item.isSelected
            })
        },
        listAvailableKasir() {
            return this.listKaryawan.filter((item) => {
                return !item.isSelected
            })
        },
    },
}
</script>

<style scoped>
.name-container{
    display: flex;
    flex-flow: wrap;
    gap: 8px;
    overflow: auto;
    max-height: 150px;
}
#customer-select >>> .form-group div input{
    border: none;
}
#customer-select >>> .form-group div input:focus{
    box-shadow: none;
}
</style>